<script setup>
import ModalWrapper from '@/modals/ModalWrapper';
import { ref } from 'vue';
import { useKaleidicalStore } from '@/stores/kaleidical';

const emit = defineEmits(['close-modal']);

const email = ref('');
const { invite } = useKaleidicalStore();

const props = defineProps({
    kaleidical: {
        type: Object,
        default: null,
    },
});

const save = async () => {
    await invite({
        email: email.value,
        hash: props.kaleidical.hash
    });

    emit('close-modal');
};
const cancel = () => {
    emit('close-modal');
};

</script>

<template>
<ModalWrapper>
    <template #header>Invite A Friend</template>

    <form @submit.prevent="save">
        <p class="mb-3">Enter Valid Email Address To Invite To Your Kaleidical</p>
        <StyledInput
            v-model="email"
            name="email"
            type="email" />
    </form>

    <template #footer>
        <StyledSaveButton modal @cancel="cancel" @save="save" />
    </template>
</ModalWrapper>
</template>
